Promise.all([
  import('../../plugins/semantic/form'),
  import(/* webpackMode: "eager" */ '../../plugins/semantic/form.scss'),
]).then(() => {
  Promise.all([
    import(/* webpackMode: "eager" */ './kentico-form.scss'),
    import('../../scripts/dbs/dbs.semantic.form'),
    import('../../plugins/semantic/input.scss'),
    import('../../plugins/semantic/label.css'),
    import('../../plugins/semantic/dropdown.scss'),
    import('../../plugins/semantic/dropdown'),
    import('../../plugins/semantic/checkbox.css'),
    import('../../plugins/semantic/checkbox'),
    import('../../plugins/semantic/transition.css'),
    import('../../plugins/semantic/transition.js'),
  ]).then(() => {
    $('.widget.kentico-form').each(function (i, el) {
      $(el).data('widget', new KenticoForm(el))
      $(el).data('widget').init()
    })
  })
})

window.handleFormSubmission = function () {
  $('.widget.kentico-form').each(function (i, el) {
    $(el).data('widget', new KenticoForm(el))
    $(el).data('widget').init()
  })
}

function KenticoForm(el) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('KenticoForm init', self)
    }

    self.el.find('.field-validation-error').each(function (i, el) {
      $(el).parents('.field').addClass('error')
    })

    self.el.find('select').dropdown({
      placeholder: false,
    })

    self.el.find('span.ktc-checkbox').addClass('ui checkbox').checkbox()
    self.el.find('span.ktc-radio').not('.ktc-radio-list').addClass('ui radio checkbox').checkbox()
    //makes kentico submit button always active
    if (self.el.find('input[type=submit]').length) {
      self.el.find('input[type=submit]').prop('disabled', false)
    }

    self.el.css('opacity', 1)
  }
}
